import { useGetOne } from 'react-admin';

const PET_PLAN_QUERY = 'plans';

export function usePlanByPetId(petPlanId) {
  return useGetOne(PET_PLAN_QUERY, { id: petPlanId }, { enabled: !!petPlanId });
}
